<template>
  <div>
    <ColorBanner />
    <v-container>
      <v-row v-if="isLoading">
        <v-col>
          <v-skeleton-loader type="image" height="56"></v-skeleton-loader>
        </v-col>
      </v-row>
      <transition name="slide-fade-down-slow">
        <v-row v-if="!isLoading">
          <v-col>
            <v-alert :type="messageType">
              {{ message }}
            </v-alert>
          </v-col>
        </v-row>
      </transition>
    </v-container>
  </div>
</template>

<script>
import ColorBanner from '@/components/Banner'
import User from '@/mixins/User'

export default {
  name: 'SessionCheckIn',

  components: {
    ColorBanner
  },

  mixins: [ User ],

  data: () => ({
    isLoading: true,
    message: '',
    messageType: '',
    showError: false
  }),

  async created () {
    await this.$store.dispatch('setUserEmployeeRecord')
    if (!this.$store.getters.getUserEmployeeRecord) {
      this.message = `We cannot find an employee with email: ${ this.user.email }`
      this.messageType = 'error'
      this.removeQueryParams()
      return this.isLoading = false
    }
    await this.$store.dispatch('getRecords', {
      table: 'Sessions',
      view: 'All Sessions',
      dispatch: 'setSessions'
    })
    if (!this.userIsSignedUp) {
      this.removeQueryParams()
      this.isLoading = false
      this.message = 'Our records indicate that you are not signed up for this session. You are not able to check-in to sessions that you are not signed up for.'
      return this.messageType = 'error'
    }
    if (this.userAlreadyCheckedIn) {
      this.messageType = 'success'
      this.message = `You've checked in to ${this.session.fields.Name}`
      this.removeQueryParams()
      return this.isLoading = false
    }
    await this.checkIn()
    this.messageType = 'success'
    this.message = `You've checked in to ${this.session.fields.Name}`
    this.removeQueryParams()
    return this.isLoading = false
  },

  computed: {
    session () {
      return this.$store.getters.getSessions.find(s => s.id === this.sessionId)
    },
    sessionId () {
      return this.$route.query.session
    },
    userAlreadyCheckedIn () {
      if (!this.session || !this.userEmployeeRecord) return false
      return this.userEmployeeRecord.fields['Sessions Checked In'].includes(this.session.id)
    },
    userIsSignedUp () {
      if (!this.session || !this.userEmployeeRecord) return false
      return this.session.fields.Attendees.includes(this.userEmployeeRecord.id)
    }
  },

  methods: {
    async checkIn () {
      let employeeCheckIns = this.userEmployeeRecord.fields['Sessions Checked In']
      if (employeeCheckIns) {
        employeeCheckIns.push(this.session.id)
      } else {
        employeeCheckIns = [this.session.id]
      }
      return await this.$store.dispatch('updateRecords', {
        table: 'Employees',
        records: [{
          id: this.userEmployeeRecord.id,
          fields: {
            'Sessions Checked In': employeeCheckIns
          }
        }]
      })
    },
    removeQueryParams () {
      this.$router.replace({
        ...this.$router.currentRoute,
        query: {
          session: undefined
        }
      })
    }
  }
}
</script>
